<div class="flex flex-col external-package h-100-percent">
  <div class="flex flex-row justify-between">
    <div class="mat-headline-6 mb-0">{{'INSTANCE_DETAILS.UPDATE_BUILD.CUSTOM_PACKAGE' | transloco }}</div>
    <mat-icon svgIcon="close" class="cursor-pointer" (click)="sidenavService.closeRightSidenav()"></mat-icon>
  </div>
  <mat-divider class="neutral-blue-6 mt-16 mb-24"></mat-divider>

  <ng-container *ngIf="!dataLoading; else loader">
    <div class="flex flex-col mat-subtitle-2 fw-700 fs-12 mb-24">
      <div class="flex mb-8 items-center" [ngClass]="{'not-selected': !selectedExternalPackage}">{{'INSTANCE_DETAILS.UPDATE_BUILD.CUSTOM_PACKAGE' | transloco | uppercase}}
        <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.UPDATE_BUILD.CUSTOM_PACKAGE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <div [ngClass]="{'not-selected': !selectedExternalPackage}">
        <mat-select class="fw-500 form-select" placeholder="{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}" [(value)]="selectedExternalPackage" panelClass="external-package" (click)="onClick($event)" (selectionChange)="externalPackageChanged($event.value)">
          <div class="flex search-bar m-8"><input [(ngModel)]="searchValue" (ngModelChange)="searchChanged(searchValue)" class="fw-400 h-34 no-border pl-12" placeholder="Search" type="text">
            <span (click)="searchChanged(searchValue)" class="cursor-pointer"><mat-icon class="mr-8 icon-md icon-color mt-4 mr-10" svgIcon="search"></mat-icon></span>
          </div>
          <mat-option class="ml-16 mr-16 mt-8 mb-8" *ngIf="!filteredExternalPackages || filteredExternalPackages?.length === 0">{{'INSTANCE_DETAILS.UPDATE_BUILD.NO_ITEMS_FOUND' | transloco}}</mat-option>
          <mat-option *ngFor="let package of filteredExternalPackages" [value]="package" [title]="package?.name">{{package?.name | titlecase}}</mat-option>
        </mat-select>
      </div>
    </div>
      
    <div class="flex flex-col endpoints update-build">
      <div *ngIf="selectedExternalPackage?.references?.length > 0; else noDataFound" class="flex flex-col border-radius">
        <div class="component-header mat-body-2 fw-700 pl-50 flex items-center">{{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco | uppercase }} ({{selectedExternalPackage?.references?.length}})</div>
        <div class="table-scroll">
        <mat-accordion #accordion [togglePosition]="'before'" [multi]="false">
          <ng-container *ngFor="let component of selectedExternalPackage?.references">
            <mat-expansion-panel (afterExpand)="onArrowClick(component)">
              <mat-expansion-panel-header class="component">
                <mat-panel-title>
                  <span class="mat-body-1 fw-500">{{ component?.component | titlecase }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex flex-col w-100-percent gap-4">
                <div class="table-section package-sections p-16">
                  <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.IMAGES' | transloco}}</span>
                  <ng-container *ngIf="dataSourceInner?.length > 0; else noInnerDataFound">
                    <div>
                      <table mat-table [dataSource]="dataSourceInner" multiTemplateDataRows class="mat-elevation ext-package">
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name">{{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                            <div class="overflow" matTooltipClass="form-tooltip right" [matTooltip]="data?.name | titlecase"
                            matTooltipPosition="{{Constants.POSITION_RIGHT}}">{{data?.name | titlecase}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="path">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path">{{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path">
                            <div class="overflow" matTooltipClass="form-tooltip right" [matTooltip]="data?.path | titlecase"
                            matTooltipPosition="{{Constants.POSITION_RIGHT}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="tag">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TAG' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'current-version': data?.version}">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                      </table>
                    </div>
                  </ng-container>
                </div>
                <div class="table-section package-sections p-16">
                  <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES' | transloco}}</span>
                  <ng-container *ngIf="dataSourceInnerPackages?.length > 0; else noInnerDataFound">
                    <div class="table-scroll">
                      <table mat-table [dataSource]="dataSourceInnerPackages" multiTemplateDataRows class="mat-elevation ext-package">
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                            <div class="overflow" matTooltipClass="form-tooltip right" [matTooltip]="data?.name | titlecase"
                            matTooltipPosition="{{Constants.POSITION_RIGHT}}">{{data?.name | titlecase}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="path">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path">
                            <div class="overflow"  matTooltipClass="form-tooltip right" [matTooltip]="data?.path | titlecase"
                            matTooltipPosition="{{Constants.POSITION_RIGHT}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="tag">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TAG' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'current-version': data?.version}">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                      </table>
                    </div>
                  </ng-container>
                </div>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
        </div>
      </div>
      <ng-template #noDataFound>
        <div *ngIf="selectedExternalPackage" class="flex justify-center pt-8 pb-8 fw-400">
          {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_COMPONENTS_AVALIABLE' | transloco }}
        </div>
      </ng-template>
      <ng-template #noInnerDataFound>
        <div>
          <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation ext-package">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
            </ng-container>
            <ng-container matColumnDef="path">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
            </ng-container>
            <ng-container matColumnDef="tag">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TAG' | transloco | uppercase }} </th>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
          </table>
          <div class="flex justify-center items-center fw-500 mb-20 mt-20 no-data">
            {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_DATA_AVAILABLE' | transloco }}
          </div>
        </div>
      </ng-template>
    </div>
    <div *ngIf="externalPackages?.length === 0" class="flex justify-center items-center fw-500 mb-20 mt-40 no-data">
      {{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES_NOT_AVAILABLE' | transloco }}
    </div>
  </ng-container>

  <ng-template #loader>
    <div class="ext-pack-loader flex items-center justify-center">
      <mat-spinner class="flex items-center justify-center" diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </div>
  </ng-template>
  <span class="flex-auto"></span>
  <mat-divider class="neutral-blue-6 mt-24 mb-24"></mat-divider>
  <div class="footer" >
    <div class="flex flex-row justify-end gap-x-6">
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button *ngIf="!viewOnly" class="accent"  [ngClass]="{'disabled': !selectedExternalPackage}" type="button" (click)="updatePackage()">{{'BUTTONS.SUBMIT' | transloco}}</button>
    </div>
  </div>
</div>